// Login-skærm: e-mail -> POST /auth/request -> neutral kvittering. dev-mode viser linket.
import { requestLink } from './api.js';

function el(tag, cls, txt) { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

export function renderLogin(root, config) {
  root.innerHTML = '';
  const wrap = el('div', 'login');
  wrap.appendChild(el('h1', 'login-title', 'KYW · Danmarksrejsen'));
  wrap.appendChild(el('p', 'login-sub', 'Tosproget oversættelses-arbejdsværktøj. Adgang kun for godkendte redaktører.'));

  const form = el('form', 'login-form');
  const input = document.createElement('input');
  input.type = 'email'; input.required = true; input.placeholder = 'din@email.dk'; input.autocomplete = 'email';
  const btn = el('button', null, 'Send login-link'); btn.type = 'submit';
  const msg = el('div', 'login-msg', '');
  form.append(input, btn);

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = input.value.trim();
    if (!email) return;
    btn.disabled = true; msg.textContent = 'Sender …';
    try {
      const res = await requestLink(email);
      msg.textContent = res.message || 'Tjek din mail for et login-link.';
      if (res.dev_link) {
        msg.appendChild(document.createElement('br'));
        const a = el('a', 'dev-link', 'DEV: åbn login-link');
        a.href = res.dev_link;
        msg.appendChild(a);
      }
    } catch {
      msg.textContent = 'Noget gik galt. Prøv igen.';
    } finally {
      btn.disabled = false;
    }
  });

  wrap.append(form, msg);
  if (config.env && config.env !== 'prod') wrap.appendChild(el('div', 'env-note', 'Miljø: ' + config.env));
  root.appendChild(wrap);
}
